const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/soh/eCheckin/sections/Versicherung/Blocks/AccidentBlock.tsx';
import { CIS4mBlock } from '@cistec/common_web/modules/CIS4m/components/CIS4mBlock';
import textMap from 'App/config/soh/eCheckin/translations';
import * as React from 'react';
import { forwardRef } from 'react';
import { getInsurancePaths } from '../Versicherung';
import { useCIS4m, useCIS4mData } from '@cistec/common_web/modules/CIS4m/hooks';
import { CIS4mDatePicker } from '@cistec/common_web/modules/CIS4m/components/CIS4mDatePicker';
import { CIS4mTextField } from '@cistec/common_web/modules/CIS4m/components/CIS4mTextField';
import { AddressBlock, AddressFieldsConfig } from 'App/components/eCheckin/components/fields/AddressBlock';
import { YesNoField } from 'App/components/eCheckin/components/fields/YesNoField';
import { fieldValueIsNot } from 'App/components/eCheckin/utils';
import { AnstellungField } from '../../components/metakat/Versicherung/AnstellungField';

type Props = {
    path: string;
    hidden?: boolean;
};

export const AccidentBlock = forwardRef((props: Props, ref: any) => {
    const formData = useCIS4mData();
    const hidden = props.hidden ?? false;

    const {
        PATH_WORKSTATUS,
        PATH_ACCIDENTDATE,
        PATH_COMPANY,
        PATH_EMPLOYER_REPORT,
        PATH_CLAIM_NR,
        PATH_ACCIDENT_INSURANCE,
    } = getInsurancePaths(props.path);

    const hideAccidentEmployedFields = fieldValueIsNot(formData, PATH_WORKSTATUS, ['employed']);
    const hideAccidentEmployerReportFields = fieldValueIsNot(formData, PATH_WORKSTATUS, ['employed', 'unemployed-RAV']);
    const isClaimNrRequired = !fieldValueIsNot(formData, PATH_EMPLOYER_REPORT, ['1']);
    const employerFieldsConfig: AddressFieldsConfig = {
        streetAndNumber: {
            included: false,
        },
        additionalInfo: {
            included: false,
        },
    };
    const accidentBlockRef = useCIS4m(ref);

    return (
        <CIS4mBlock ref={accidentBlockRef} hidden={hidden}>
            <CIS4mDatePicker label={textMap.accidentDate} path={PATH_ACCIDENTDATE} required={true} />
            <AnstellungField label={textMap.workStatus} path={PATH_WORKSTATUS} required={true} />
            <CIS4mBlock hidden={hideAccidentEmployedFields}>
                <CIS4mTextField label={textMap.insuranceEmployer} path={PATH_COMPANY} required={true} />
                <AddressBlock basePath={props.path} fieldsConfig={employerFieldsConfig} required={true} />
            </CIS4mBlock>
            <CIS4mBlock hidden={hideAccidentEmployerReportFields}>
                <YesNoField label={textMap.employerReport} path={PATH_EMPLOYER_REPORT} required={true} />
                <CIS4mTextField label={textMap.claimNum} path={PATH_CLAIM_NR} required={isClaimNrRequired} />
                <CIS4mTextField label={textMap.accidentInsurance} path={PATH_ACCIDENT_INSURANCE} required={true} />
            </CIS4mBlock>
        </CIS4mBlock>
    );
});

AccidentBlock.displayName = 'AccidentBlock';
